/*
 * Copyright (c) 2019-2022 LogMeIn
 * All Rights Reserved Worldwide.
 *
 * THIS PROGRAM IS CONFIDENTIAL AND PROPRIETARY TO LOGMEIN
 * AND CONSTITUTES A VALUABLE TRADE SECRET.
 */

import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Flex, Text } from '@getgo/chameleon-chakra-ui';
import { AlwaysUseNativeCheckbox } from './AlwaysUseNativeCheckbox';

const messages = defineMessages({
  autoJoinCheckboxLabel: {
    id: 'success.autoJoinCheckboxLabel',
  },
});

export const AlwaysUseNative: React.FC = () => {
  const { formatMessage: f } = useIntl();
  const ariaDescribedByLabel = 'checkboxlabel';
  return (
    <Flex>
      <AlwaysUseNativeCheckbox ariaDescribedByLabel={ariaDescribedByLabel} />
      <Text fontSize='0.875rem' id={ariaDescribedByLabel}>
        {f(messages.autoJoinCheckboxLabel)}
      </Text>
    </Flex>
  );
};
